<template>
  <v-card :class="{ isUnavailable: !host.isActive }">
    <v-img
      :src="`${apiUrl}/v1/cache/image/${host.photoUrlEstate[0]}.png`"
      height="200px"
      v-if="host.photoUrlEstate.length > 0"
      lazy-src
      gradient="to top right, rgba(100,115,201,.15), rgba(25,32,72,.3)"
    >
      <v-container fill-height fluid pa-2>
        <v-layout fill-height>
          <v-flex xs12 align-end flexbox>
            <span class="headline white--text">{{ host | hostSummary }}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
    <v-card-title v-else class="card-cont-title headline white--text">{{
      host | hostSummary
    }}</v-card-title>
    <v-alert
      :value="
        !host.geoLoc ||
        !host.geoLoc.coordinates ||
        host.geoLoc.coordinates.length === 0
      "
      type="warning"
    >
      Pas de géolocalisation (adresse invalide ?)
    </v-alert>
    <v-card-text class="description">
      <p>{{ host.address }}</p>
      <p class="grey--text">{{ host.description }}</p>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn flat @click="$router.push(`/host/${host._id}`)" color="primary"
        >Voir le bien</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { API_URL } from "../../../webapp-commons/config";

export default {
  name: "HostsGridItem",
  props: ["host"],
  data: function () {
    return {
      apiUrl: API_URL,
    };
  },
  methods: {},
  computed: {},
  filters: {
    hostSummary({ numberOfRoom, carrez, price }) {
      let data = [];
      if (numberOfRoom != -1) {
        data.push(`${numberOfRoom} pièce${numberOfRoom > 1 ? "s" : ""}`);
      }
      if (carrez != null) {
        data.push(`${carrez}m²`);
      }
      if (price != null) {
        data.push(`${price}€`);
      }
      return data.join(", ");
    },
  },
};
</script>

<style scoped>
.description {
  margin: auto;
}

.description p:last-child {
  overflow: hidden;
  width: 99%;
  white-space: pre-wrap;
  font-size: 0.9rem;
  height: 50px;
}

.isUnavailable {
  opacity: 0.5;
}

.card-cont-title {
  height: 200px;
  justify-content: flex-start;
  align-items: flex-start;
  background: linear-gradient(
      to top right,
      rgba(100, 115, 201, 0.15),
      rgba(25, 32, 72, 0.3)
    )
    white;
}
</style>
